import { useState } from 'react';
import {
	IoIosCheckmarkCircle,
	IoIosCloseCircle,
	IoIosHelpCircle,
} from 'react-icons/io';
import { IoTrashOutline } from 'react-icons/io5';

import Error from '../Error';
import Loader from '../Loader';
import Pagination from '../Pagination';
import FilePreviewModal from '../utils/FilePreviewModal';
import DrawerModel from '../utils/drawer';
import { eventStatusColor } from '../utils/eventStatusColor';
import { tableBackgroundColor } from '../utils/tableBackgroundColor';
import { CreateTestimonial } from './CreateTestimonial';

import { TestimonialError } from '@/exceptions/testimonial/testimonial.enum';
import useDeleteTestimonial from '@/hooks/testimonial/useDeleteTestimonial';
import { useGetAllTestimonials } from '@/hooks/testimonial/useGetAllTestimonial';
import { EventStatus } from '@/interfaces/entities/event';
import {
	DrawerTestimonial,
	ITestimonial,
} from '@/interfaces/entities/testimonal';
import { notificationService } from '@/services/notification.service';
import useChangeTestimonialStatus from '@/hooks/testimonial/useChangeStatus';




export const TestimonialTable = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const [modalVisible, setModalVisible] = useState(false);
	const [url, setUrl] = useState('');
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const [isTestimonial, setIsTestimonial] = useState<ITestimonial | null>(null);
 const { mutate } = useChangeTestimonialStatus();
	const { testimonials, isLoading, isError, error, totalPages, isPending } =
		useGetAllTestimonials(currentPage);
	const deleteTestimonial = useDeleteTestimonial();
	const isFetching = isLoading || isPending;

	if (isFetching) {
		return <Loader />;
	}

	if (isError) {
		return (
			<Error message={error ? error.message : TestimonialError.TEST_ERROR} />
		);
	}

	const openEditModal = (blogger: ITestimonial) => {
		setIsTestimonial(blogger);
		setIsCreateModalOpen(true);
	};

	const openCreateModal = () => {
		setIsCreateModalOpen(true);
	};

	const handleDelete = async (id: number|null) => {
		if(id){
		try {
			deleteTestimonial.mutate(id);
		} catch (error) {
			notificationService.error('Testimonial deleted failed');
		}}
	};

	const handleToggle = () => {
		setIsCreateModalOpen(false);
		setIsTestimonial(null);
	};

	const handlePreview = (url: string | null) => {
		if (url) {
			setUrl(url);
			setModalVisible(true);
		}
	};

	const eventStatus = (status: EventStatus) => {
		const color = eventStatusColor(status);
		switch (status) {
			case EventStatus.APPROVED:
				return (
					<IoIosCheckmarkCircle
						className={`${color} inline-block align-middle`}
						title={EventStatus.APPROVED}
						size={22}
					/>
				);
			case EventStatus.REJECTED:
				return (
					<IoIosCloseCircle
						className={`${color} inline-block align-middle`}
						title={EventStatus.REJECTED}
						size={22}
					/>
				);
			case EventStatus.PENDING:
				return (
					<IoIosHelpCircle
						className={`${color} inline-block align-middle`}
						title={EventStatus.PENDING}
						size={22}
					/>
				);
			default:
				return null;
		}
	};
	return (
		<div className="px-4 sm:px-6 lg:px-8 w-full mb-10">
			<div className="sm:flex sm:items-center">
				<div className="flex justify-between font-bold sm:flex-auto">
					<h1
						data-test="h1-categories"
						className="text-base font-semibold leading-6 text-gray-900"
					>
						Testimonials
					</h1>
					<button
						className="text-indigo-600 hover:text-indigo-900"
						data-test="button-add-category"
						onClick={openCreateModal}
					>
						Add Testimonial
					</button>
				</div>
			</div>
			{testimonials.length ? (
				<div className="mt-8 w-full  flow-root">
					<div className=" w-full overflow-x-auto">
						<div className="inline-block  min-w-[1200px] w-full py-2 align-middle">
							<table className="min-w-full table-auto divide-y divide-gray-300 border-red-300  border-spacing-x-4">
								<thead>
									<tr className="gap-x-2">
										<th
											scope="col"
											className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900 "
											data-test="th-id"
										>
											ID
										</th>
										<th
											scope="col"
											className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-name"
										>
											Name
										</th>
										<th
											scope="col"
											className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-email"
										>
											Email
										</th>

										<th
											scope="col"
											className="w-2/12 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-address"
										>
											Address
										</th>
										<th
											scope="col"
											className=" w-1/12 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-mobile"
										>
											Mobile
										</th>
										<th
											scope="col"
											className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-organization"
										>
											organization
										</th>
										<th
											scope="col"
											className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-comments"
										>
											Comments
										</th>
										<th
											scope="col"
											className="w-0.5/12 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-image"
										>
											image
										</th>
										<th
											scope="col"
											className="w-1/12 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
										>
											<span className="">status Action</span>
										</th>

										<th
											scope="col"
											className=" w-0.5/12 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
											data-test="th-status"
										>
											Status
										</th>

										<th
											scope="col"
											className="w-1/12 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
										>
											<span className="">Actions</span>
										</th>
									</tr>
								</thead>
								<tbody className="divide-y divide-gray-200">
									{testimonials.map((comment: ITestimonial, index: number) => {
										return (
											<tr
												key={comment.id}
												className={`${tableBackgroundColor(
													index,
												)} hover:bg-gray-200 min-h-8 gap-x-2`}
											>
												<td
													data-test="td-id"
													className="text-center max-w-sm py-4  text-sm font-medium text-gray-900 "
												>
													{comment.id}
												</td>
												<td
													data-test="td-name"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													{comment.name}
												</td>
												<td
													data-test="td-email"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													{comment.email ?? '-'}
												</td>
												<td
													data-test="td-address"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													{comment.address ?? '-'}
												</td>
												<td
													data-test="td-mobile"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													{comment.mobile}
												</td>

												<td
													data-test="td-organization"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													{comment.organization ?? '-'}
												</td>
												<td
													data-test="td-description"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													{comment.comments.length > 100
                                                    ? `${comment.comments.slice(0, 100)}...`
                                                    : comment.comments}
												</td>
												<td
													data-test="td-image"
													className="text-center max-w-md py-4 text-sm text-gray-500"
												>
													<button
														data-test="image-button"
														className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
														onClick={() => handlePreview(comment.img)}
													>
														{comment.img?'View':'-'}
													</button>
												</td>

												<td className="px-3 py-3.5 text-center text-sm text-gray-900">
													{comment.status !== EventStatus.APPROVED && (
														<button
															onClick={() =>
															    mutate({
															        Id: comment.id as number,
															        status: EventStatus.APPROVED,
															    })
															}
															className="text-indigo-600 hover:text-indigo-900 disabled:text-gray-400"
															data-test="btn-approve"
															disabled={isFetching}
														>
															Approve
														</button>
													)}
													{comment.status !== EventStatus.REJECTED && (
														<button
															onClick={() =>
															    mutate({
															        Id: comment?.id as number,
															        status: EventStatus.REJECTED,
															    })
															}
															className="text-indigo-600 hover:text-indigo-900 disabled:text-gray-400"
															disabled={isFetching}
															data-test="btn-reject"
														>
															Reject
														</button>
													)}
												</td>
												<td
													data-test="td-status"
													className="px-3 py-3.5 text-center text-sm text-gray-900 break-words"
												>
													{eventStatus(comment.status)}
												</td>
												<td
													data-test="edit-notification-button"
													className="text-center text-md font-semibold "
												>
													<div className="flex justify-center items-center gap-6">
														<button
															data-test="edit-testimonial-button"
															className="text-indigo-600 hover:text-indigo-900"
															onClick={() => openEditModal(comment)}
														>
															Edit
															<span className="sr-only">{comment.id}</span>
														</button>

														{typeof comment?.id === 'number' && (
															<IoTrashOutline
																className="cursor-pointer"
																onClick={() => handleDelete(comment.id ||null)}
															/>
														)}
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
					<Pagination
						currentPage={currentPage}
						setCurrentPage={setCurrentPage}
						totalPages={totalPages as number}
					/>
				</div>
			) : (
				<div className="w-full">
					<h1
						data-test="h1-comments"
						className="text-base font-semibold text-center mt-20 leading-6 text-gray-900"
					>
						No Testimonials Available
					</h1>
				</div>
			)}
			<FilePreviewModal
				visible={modalVisible}
				url={url}
				onClose={() => setModalVisible(false)}
			/>

			<DrawerModel
				isOpen={isCreateModalOpen}
				isTitle={
					isTestimonial ? DrawerTestimonial.Edit : DrawerTestimonial.Create
				}
				setToggle={handleToggle}
			>
				<CreateTestimonial
					editTestimonial={isTestimonial ?? null}
					setToggle={handleToggle}
				/>
			</DrawerModel>
		</div>
	);
};
